import * as Yup from 'yup';

export const contactDetailOverviewValidationSchema = Yup.object().shape({
    addresses: Yup.array().of(
        Yup.object().shape({
            street: Yup.string().required('app.error.required'),
            zip: Yup.string().required('app.error.required'),
            city: Yup.string().required('app.error.required'),
            country: Yup.object().required('app.error.required'),
            isDefaultAddress: Yup.boolean().required('app.error.required'),
        })
    ),
    mainEmail: Yup.string().email('app.error.email').required('app.error.required'),
    emails: Yup.array().of(
        Yup.object().shape({
            type: Yup.mixed().required(),
            email: Yup.string().email('app.error.email').required('app.error.required'),
        })
    ),
    phones: Yup.array().of(
        Yup.object().shape({
            type: Yup.mixed().required(),
            number: Yup.string().required('app.error.required'),
        })
    ),
    firstName: Yup.string().required('app.error.required'),
    lastName: Yup.string().required('app.error.required'),
    formOfAddress: Yup.number().required('app.error.required'),
});
